<template>
  <div class="dynamic-fields">
    <div class="path-wrapper">
      <div class="left">
        {{ atSelectTypePath }}
      </div>
      <div class="right">
        {{ atSelectType ? $t('filter.'+ atSelectType.key + '.label') : '' }}
      </div>
    </div>
    <template v-if="atSelectType && renderDynamicField">
      <template v-if="atSelectType.type === 'list'">
        <template v-for="atItem in attributeValues">
          <div
            :key="atItem.id"
            class="subcategory"
            :class="{make: atItem === getFieldValue(atSelectType)}"
            @click="setSelectFieldValue(atItem, atSelectType)"
          >
            <i
              class="subcategory-icon"
              :class="['icon-'+atItem.key]"
            />
            <span>{{ atItem.name }}</span>
            <div
              :class="{ hide: atItem === getFieldValue(atSelectType) }"
              class="arrow"
            >
              <i class="icon-arrow-r" />
            </div>
          </div>
        </template>
      </template>
      <el-row
        v-if="atSelectType.type === 'range'"
        class="range-slider p-l-xs-45 p-r-xs-45 p-b-xs-15"
      >
        <div class="block">
          <range-primary
            tooltip-class="tooltip-primary"
            :show-tooltip="true"
            range
            transition
            :value="getFieldValue(atSelectType)"
            :force-tooltip-open="true"
            :min="atSelectType.type_data_parsed.min | limitReplacers('number')"
            :max="atSelectType.type_data_parsed.max | limitReplacers('number')"
            @change="setFieldValue($event, atSelectType)"
          />
        </div>
        <div class="text-center">
          <el-button @click="setSelectFieldValue(null, atSelectType)">
            {{ $t('filter.next') }}
          </el-button>
        </div>
      </el-row>
      <template v-if="atSelectType.type === 'address'">
        <div class="block p-l-xs-15 p-r-xs-15 p-b-xs-15">
          <location @place_changed="setSelectFieldValue(null, atSelectType)" />
          <div class="text-center">
            <el-button @click="setSelectFieldValue(null, atSelectType)">
              {{ $t('filter.next') }}
            </el-button>
          </div>
        </div>
      </template>
      <template v-if="atSelectType.type === 'sort'">
        <div class="block p-l-xs-15 p-r-xs-15 p-b-xs-15">
          <sort-ads-dropdown
            :list-type="true"
            @input="setSelectFieldValue(null, atSelectType)"
          />
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import isEqual from 'lodash-es/isEqual';
import dynamicFields from '@/mixins/filters/dynamic-fields';
import mobileDynamicFields from '@/mixins/filters/mobile-dynamic-fields';
import Location from '@/components/MainLeftFilters/Location';
import RangePrimary from '../RangePrimary';
import SortAdsDropdown from '../../Ads/SortAdsDropdown';

export default {
  components: {
    RangePrimary,
    Location,
    SortAdsDropdown,
  },
  mixins: [dynamicFields, mobileDynamicFields],
  data() {
    return {
      allowAllFieldTypes: true,
    };
  },
  computed: {
    attributeValues() {
      if (this.atSelectType && this.atSelectType.type_data_parsed) {
        if (this.atSelectType.parent_key) {
          const atParentType = this.attributeTypes
            .find(item => item.key === this.atSelectType.parent_key);
          let atParentValue = this.getFieldValue(atParentType);
          atParentValue = atParentValue && atParentValue.value ?
            atParentValue.value : atParentValue;
          if (atParentType && atParentValue) {
            return this.atSelectType.type_data_parsed
              .filter(item => item.parent === atParentValue);
          }
        }
        return this.atSelectType.type_data_parsed;
      }
      return null;
    },
  },
  watch: {
    attributeTypes(newVal, oldVal) {
      // Slider tooltip not freeze fix ( when dynamic attribute fields change )
      if (newVal && oldVal && !isEqual(newVal.map(item => item.id), oldVal.map(item => item.id))) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MainLeftFilters/LeftFilter/DynamicFieldsMobile.vue